import type Category from '../types/category';
import getCategoryNodeWithCount from './getCategoryNodeWithCount';
import notEmpty from './notEmpty';

const addCountToTree = (
    tree: Category[],
    counts: {
        category: {
            id: string;
        };
        total: number;
    }[],
    ignoredSelectedCategory?: string
): Category[] => {
    const treeMapperFn = (node: Category): Category | null => {
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        if (!node.children || node.children.length === 0) {
            const nodeWithCount = getCategoryNodeWithCount(node, counts);
            if (nodeWithCount.count) {
                return { ...nodeWithCount };
            }

            if (node.id === ignoredSelectedCategory) {
                return {
                    ...node,
                    count: undefined,
                };
            }

            return node;
        }

        const childNodeWithCount = getCategoryNodeWithCount(node, counts);
        if (childNodeWithCount.count) {
            return {
                ...childNodeWithCount,
                children: node.children.map(treeMapperFn).filter(notEmpty),
            };
        }

        if (node.id === ignoredSelectedCategory) {
            return {
                ...node,
                count: undefined,
            };
        }

        return node;
    };

    return tree.map(treeMapperFn).filter(notEmpty);
};

export default addCountToTree;
